/* ==========================================================================
   Libro de Reclamaciones — client behavior
   Vanilla IIFE, no dependencies. Responsibilities:
   (a) fill the readonly "Fecha y hora" (es-PE / America/Lima) and a
       registration code LR-YYYYMMDD-HHMM-XXX on load;
   (b) toggle the guardian block when "Soy menor de edad" is checked,
       flipping [hidden] and required on its fields;
   (c) persist the registration code to sessionStorage on submit;
   (d) on the success view, read the stored code and show it.
   No alert/confirm/prompt.
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'vlxLibroReclamacionesCode';

  document.addEventListener('DOMContentLoaded', function () {
    // (d) Success view: surface the stored registration code.
    var success = document.querySelector('[data-lr-success]');
    if (success) {
      var out = success.querySelector('[data-lr-code-out]');
      var stored = readStored();
      if (out) {
        if (stored) {
          out.textContent = stored;
        } else {
          var line = success.querySelector('[data-lr-code-line]');
          if (line) { line.hidden = true; }
        }
      }
      return; // The form is not rendered on the success view.
    }

    var form = document.getElementById('LibroReclamacionesForm');
    if (!form) { return; }

    var now = new Date();

    // (a) Fill the readonly auto fields.
    var dateTimeInput = form.querySelector('[data-lr-datetime]');
    var codeInput = form.querySelector('[data-lr-code]');
    if (dateTimeInput) { dateTimeInput.value = formatDateTime(now); }
    if (codeInput) { codeInput.value = buildCode(now); }

    // (b) "Soy menor de edad" toggle → reveal + require the guardian block.
    var minorToggle = form.querySelector('[data-lr-minor-toggle]');
    var guardianGroup = form.querySelector('[data-lr-guardian-group]');
    if (minorToggle && guardianGroup) {
      var guardianFields = guardianGroup.querySelectorAll('input, select, textarea');
      var applyMinorState = function () {
        var on = minorToggle.checked;
        guardianGroup.hidden = !on;
        for (var i = 0; i < guardianFields.length; i++) {
          if (on) {
            guardianFields[i].setAttribute('required', '');
            guardianFields[i].setAttribute('aria-required', 'true');
          } else {
            guardianFields[i].removeAttribute('required');
            guardianFields[i].removeAttribute('aria-required');
            guardianFields[i].value = ''; // Don't submit stale guardian data.
          }
        }
      };
      minorToggle.addEventListener('change', applyMinorState);
      applyMinorState(); // Sync initial state (unchecked → hidden, not required).
    }

    // (c) Persist the code so the success view can show it.
    form.addEventListener('submit', function () {
      if (codeInput && codeInput.value) {
        try { sessionStorage.setItem(STORAGE_KEY, codeInput.value); } catch (e) {}
      }
    });
  });

  function readStored() {
    try { return sessionStorage.getItem(STORAGE_KEY) || ''; } catch (e) { return ''; }
  }

  function pad2(n) { return n < 10 ? '0' + n : '' + n; }

  // Human-readable date/time in Lima local time (es-PE).
  function formatDateTime(date) {
    try {
      return new Intl.DateTimeFormat('es-PE', {
        timeZone: 'America/Lima',
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).format(date);
    } catch (e) {
      return pad2(date.getDate()) + '/' + pad2(date.getMonth() + 1) + '/' + date.getFullYear() +
        ' ' + pad2(date.getHours()) + ':' + pad2(date.getMinutes());
    }
  }

  // LR-YYYYMMDD-HHMM-XXX using Lima wall-clock time + a random 3-digit suffix.
  function buildCode(date) {
    var p = limaParts(date);
    var rand = ('00' + Math.floor(Math.random() * 1000)).slice(-3);
    return 'LR-' + p.year + p.month + p.day + '-' + p.hour + p.minute + '-' + rand;
  }

  // Derive America/Lima wall-clock components without external dependencies.
  function limaParts(date) {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Lima',
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(date);
      var map = {};
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type !== 'literal') { map[parts[i].type] = parts[i].value; }
      }
      return {
        year: map.year,
        month: map.month,
        day: map.day,
        hour: map.hour === '24' ? '00' : map.hour, // Some engines emit 24 for midnight.
        minute: map.minute
      };
    } catch (e) {
      return {
        year: '' + date.getFullYear(),
        month: pad2(date.getMonth() + 1),
        day: pad2(date.getDate()),
        hour: pad2(date.getHours()),
        minute: pad2(date.getMinutes())
      };
    }
  }
})();
